<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Order Confirmation</h3>
  </div>
  <div class="col-3" (click)="closeComponent()" style="text-align: right;">
    <i class="material-icons" style="cursor: pointer; font-size: 28px;">
      cancel
    </i>
  </div>

</div>
<br>
<div class="row" style="color: #7b8182; font-size: 21px;">
  <div class="col" style="text-align: right;">
    Order value
  </div>
  <div class="col-4" style="text-align: right;">{{final_price | currency :'INR'}}</div>
  <div class="col-2"></div>
</div><br>
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row" style="font-size: 21px;">
  <div class="col" style="text-align: right;">
    Amount payable
  </div>
  <div class="col-4" style="text-align: right;">{{final_price | currency :'INR'}}</div>
  <div class="col-2"></div>
</div>
<div class="row">
  <div class="col-12">
    <hr style="background-color: #b7b6b6">
  </div>
</div>
<div class="row" style="font-size: 28px; margin-top: 16%;">
  <div class="col-2" *ngIf="disable_button">
    <mat-spinner [diameter]="40"></mat-spinner>
  </div>
  <div class="col" style="margin-top: -7%;">
    <label>Payment Method <i class="material-icons" style="color: red;font-size: 14px;">star</i></label>
    <mat-select [(ngModel)]="payment_method_id"
      style="border: 1px solid; border-radius: 10px; text-align: center; padding: 10px;">
      <mat-option *ngFor="let payment_method of payment_method_list" [value]="payment_method.id">
        {{payment_method.name}}
      </mat-option>
    </mat-select>
  </div>
  <div class="col" style="text-align: center;">
    <button (click)="finalizeCalled()" onclick="this.disabled=true" mat-raised-button class="button-class" style="font-size: 23px;"
      [disabled]="checkForDisable()" id="register_button">Finalize
      order</button>
  </div>
</div>
